import {
  CHANGE_PASSWORD,
  FORGOT,
  LOGIN,
  RESET,
  UPDATE_FCM_TOKEN,
  VERIFY_OTP,
} from "../../../api/endPoint";
import instance from "../../../helpers/axios";
import { instance as rawAxios } from "../../../hooks/axios";

const login = (data) => {
  return instance.post(LOGIN, {
    email: data?.email,
    password: data?.password,
  });
};

const forgot = (data) => {
  return instance.post(FORGOT, {
    email: data,
  });
};

const verifyOtp = async (data) => {
  try {
    const response = await rawAxios.post(VERIFY_OTP, {
      otp: data?.otp,
      otpRequestId: data?.otpRequestId,
    });
    return response?.data ?? response;
  } catch (error) {
    const payload = error?.response?.data ?? {};
    const messageCode = payload?.messageCode || payload?.message || "";
    throw {
      message: messageCode || error?.message || "OTP verify failed",
      status: error?.response?.status,
      messageCode,
    };
  }
};

const reset = (data) => {
  return instance.post(RESET, {
    // email: data.email,
    resetToken: data?.resetToken,
    password: data?.password,
  });
};

const changePassword = (data) => {
  return instance.post(CHANGE_PASSWORD, {
    oldPassword: data?.oldpassword,
    newPassword: data?.newpassword,
  });
};
const updateToken = (data) => {
  return instance.post(UPDATE_FCM_TOKEN, {
    token: data?.token,
    platform: data?.platform,
  });
};

const authServices = {
  login,
  forgot,
  verifyOtp,
  reset,
  changePassword,
  updateToken,
};

export default authServices;
